import { render, staticRenderFns } from "./IconLotPlaceholder.vue?vue&type=template&id=768ead9e&"
import script from "./IconLotPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./IconLotPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports